import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import NotificationsContainer from '../../components/Notifications/NotificationsContainer';

// Constants
import { APP_TITLE, PAGE_TITLE_REPORTS } from '../../utils/constants';
import { GetString } from '../../components/StringResourceManager';
import { ApplicationState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { useEffect } from 'react';
import {
  getAssetStoreList,
  getLaneNumbers,
} from '../../store/Assets/AssetsActions';
import { getCurrentIssueCategories } from '../../store/Devices/AssetStatesActions';
import { fetchCategories } from '../../store/Reports/ReportsActions';
import { pingSchedulerService } from '../../store/Notifications/NotificationsActions';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      '& > *': {
        margin: theme.spacing(2),
      },
    },
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      flexDirection: 'column',
    },
  }),
);

export default function NotificationsMenu() {
  const classes = useStyles();
  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getAssetStoreList(dispatch);
      getLaneNumbers(dispatch);
      getCurrentIssueCategories(dispatch);
      fetchCategories(dispatch);
      pingSchedulerService(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_NOTIFICATIONS')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_NOTIFICATIONS')}
      />
      <Paper className={classes.paperGrid}>
        <NotificationsContainer />
      </Paper>
    </>
  );
}
